import React from "react";
import { useNavigate } from "react-router-dom";
import ShineButton from "../../components/ShineButton";
import RotatingText from "../../components/RotatingText";
import "./css/HeroSection.css";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleUnravelledClick = () => {
    navigate("/contact-us");
  };

  const side1 = [
    "Publishers",
    "Brands",
    "Attention",
    "Traffic",
    "Monetization",
    "Intent",
    "Insights"
  ];

  const side2 = [
    "Advertisers",
    "Audiences",
    "Conversion",
    "Traction",
    "Clean-Pages",
    "Impact",
    "Outcomes"
  ];

  return (
    <section
      className="hero-section"
    >
      <div className="hero-inner">
        <div className="hero-badge">
          <span className="hero-badge-text">Built for brands. Loved by Publishers.</span>
        </div>

        <h1 className="hero-title">
          <div className="hero-title-main">Ravooka connects</div>
          <div className="hero-rotating-wrapper">
            <RotatingText
              texts={side1}
              mainClassName="hero-rotating-text hero-rotating-text--side1"
              elementLevelClassName="hero-rotating-char"
              staggerDuration={0.02}
              staggerFrom="first"
              splitBy="characters"
              rotationInterval={3500}
            />
            <span className="hero-to-text">with</span>
            <RotatingText
              texts={side2}
              mainClassName="hero-rotating-text hero-rotating-text--side2"
              elementLevelClassName="hero-rotating-char"
              staggerDuration={0.02}
              staggerFrom="last"
              splitBy="characters"
              rotationInterval={3500}
            />
          </div>
        </h1>

        <p className="hero-subtext">
          A premium digital media advertising platform connecting advertisers and news publishers — Built on Research, Validated by Data.
        </p>

        <div className="hero-actions">
          <ShineButton
            className="shine-btn--header"
            text="Start Advertising"
            onClick={handleUnravelledClick}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
